import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Paginator' })({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 12,
        paddingTop: 8,
        paddingBottom: 8
    },
    rowsPerPageContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
    },
    rowsPerPageLabel: {
        fontWeight: 500,
        fontSize: 13,
        lineHeight: '150%',
        color: '#8E8E8E',
        letterSpacing: '-0.26px'
    },
    pagination: {
        '& ul': {
            display: 'flex',
            gap: 2
        }
    },
    paginationItem: {
        margin: 0,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '32px',
        borderRadius: 8,
        border: '1px solid #ECECEC',
        color: '#232323',
        height: 32
    },
    selected: {
        pointerEvents: 'none',
        border: 0,
        background: 'inherit !important',
        fontWeight: 600
    },
    previousNext: {
        borderColor: '#F5F5F5',
        background: '#F5F5F5',
        color: '#8E8E8E'
    },
    menu: {
        marginTop: 4
    },
    menuList: {
        padding: 8
    },
    menuItem: {
        fontWeight: 400,
        fontSize: 13,
        lineHeight: '16px',
        color: '#38383A',
        padding: '8px 24px 8px 16px',
        borderRadius: 8,
        '&:hover': {
            background: '#FAFAFA'
        }
    },
    menuItemSelected: {
        background: 'transparent !important',
        fontWeight: 'bold'
    },
    rowsPerPageSelectRoot: {
        borderRadius: 8,
        fontWeight: 400,
        fontSize: 13,
        color: '#38383A',
        background: '#FAFAFA',
        '& fieldset': {
            border: '1px solid #ECECEC !important'
        }
    },
    rowsPerPageSelect: {
        padding: '8px 36px 8px 12px !important',
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px !important',
        minHeight: 'auto !important',
        '&:focus': {
            borderRadius: 8,
            backgroundColor: 'transparent'
        }
    },
    rowsPerPageSelectIcon: {
        top: 9,
        right: 12,
        transition: 'transform 0.2s'
    },
    paginationContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    paginationLabel: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '140%',
        color: '#38383A'
    },
    totalCountContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 4
    },
    totalCountLabel: {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '140%',
        color: '#38383A',
        '&:after': {
            content: '":"'
        }
    },
    totalCountValue: {
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '140%',
        color: '#38383A'
    }
});
